import React from 'react';
import { Route } from '../Routing/types';
import {
  Weight,
  DietMode,
  GoalWeight,
  ActivityLevel,
  SpontaneousActivityLevel,
  Summary,
} from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/weight',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <Weight />,
  },
  {
    path: '/diet-mode',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietMode />,
  },
  {
    path: '/goal-weight',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <GoalWeight />,
  },
  {
    path: '/spontaneous-activity-level',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <SpontaneousActivityLevel />,
  },
  {
    path: '/activity-level',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <ActivityLevel />,
  },
  {
    path: '/summary',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <Summary />,
  },
];

export default descendantRoutes;
